import React, { useState, useEffect } from 'react';
import Header from '../components/layout/Header';
import Drawer from '../components/layout/Drawer';

const BookNow = () => {
  const [isDrawerOpen, setDrawerOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false); // State for header scroll effect

  const openDrawer = () => {
    setDrawerOpen(true);
    document.documentElement.classList.add('menu-open');
  };

  const closeDrawer = () => {
    setDrawerOpen(false);
    document.documentElement.classList.remove('menu-open');
  };

  // Intersection Observer for header scroll effect
  useEffect(() => {
    const hero = document.getElementById('hero'); // Observe the hero section

    const io = new IntersectionObserver(([entry]) => {
      const atTop = entry.isIntersecting && entry.intersectionRatio > 0;
      setScrolled(!atTop);
    }, {root:null, threshold:0, rootMargin:'-88px 0px 0px 0px'}); // Adjust rootMargin based on header height

    if (hero) {
      io.observe(hero);
    }

    return () => {
      if (hero) {
        io.unobserve(hero);
      }
    };
  }, []);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        closeDrawer();
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  return (
    <>
      <Header onMenuClick={openDrawer} scrolled={scrolled} />
      <Drawer isOpen={isDrawerOpen} onClose={closeDrawer} />
      <div id="hero" style={{ background: '#D9CAB3', minHeight: '100vh', padding: '120px 24px' }} data-aos="fade-up">
        <h1>Book Now</h1>
      </div>
    </>
  );
};

export default BookNow;